import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDown } from '@fortawesome/pro-solid-svg-icons';
import { NSInput } from 'bricks';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { URLS } from 'services/urls';
import { ISignUpManager } from '../../useSignUpManager';
import { TermsAndConditionsBlock } from '../../../../../components/signup/TermsAndConditionsBlock';

interface IProps {
    onClickManualSignUp: () => void;
    signUpManager: ISignUpManager;
}

const SignUpMethodSection: React.FC<IProps> = ({ onClickManualSignUp, signUpManager }) => {
    const {
        SSOSignUpEnabled,
        organizationName,
        isOrgNameValid,
        orgValidationSuccess,
        handleOrganizationNameChange,
        handleLinkedInSignUp,
    } = signUpManager;

    return (
        <>
            <div className="DirectSignUp__SubHeading">
                Provide your organization name to start using Northspyre Deal.
            </div>
            <div className="DirectSignUp__FormFields mb-1">
                <div className="DirectSignUp__InputWrapper">
                    <label htmlFor="organizationName" className="DirectSignUp__SectionLabel">Organization name</label>
                    <NSInput
                        id="organizationName"
                        name="organizationName"
                        type="text"
                        placeholder="Get started with your organization name"
                        value={organizationName.value}
                        onChange={handleOrganizationNameChange}
                        className="DirectSignUp__Input"
                        autoComplete="organization"
                        invalid={!isOrgNameValid}
                    />
                </div>
                {!isOrgNameValid && (
                    <div className="DirectSignUp__ErrorMessage">
                        <p className="DirectSignUp__ErrorMessage__Label">
                            <span className="">Duplicate organization:</span>
                            {' '}
                            This organization already exists.
                        </p>
                        <p className="DirectSignUp__ErrorMessage__Description">
                            Contact an admin at your organization using Northspyre to invite you.
                            If your organization does not use Northspyre, try adjusting your organization name.
                        </p>
                    </div>
                )}
            </div>
            <TermsAndConditionsBlock />
            <div className="DirectSignUp__Arrow">
                <FontAwesomeIcon icon={faDown} />
            </div>
            <div className="DirectSignUp__FormSubmit">
                <NSButtonBase
                    color="secondary"
                    callback={handleLinkedInSignUp}
                    className="DirectSignUp__LinkedIn"
                    innerContentClassName="DirectSignUp__LinkedIn__Content"
                    disabled={!SSOSignUpEnabled}
                    dataTestId="linkedInButton"
                >
                    <span>
                        <img src={URLS.IMAGE_CLOUDFRONT_URL('socials/linkedin.png')} alt="LinkedIn" />
                        {' '}
                        Sign up with LinkedIn
                    </span>
                </NSButtonBase>
            </div>
            <div className="DirectSignUp__Divider">
                <hr className="DirectSignUp__DividerLine" />
                <span className="DirectSignUp__DividerText">OR</span>
                <hr className="DirectSignUp__DividerLine" />
            </div>
            <div className="DirectSignUp__FullWidth">
                <NSButtonBase
                    outline
                    color="primary"
                    callback={onClickManualSignUp}
                    className="DirectSignUp__Button"
                    disabled={!orgValidationSuccess}
                    dataTestId="createAccountButton"
                >
                    Create account with my email
                </NSButtonBase>
            </div>
        </>
    );
};

export default SignUpMethodSection;
